import { UpcomingConsultationData } from './UpcomingConsultationMapper.types'
import { DateTime } from 'luxon'
import { UpcomingConsultation } from '../types'
import { autoCapitalizeName } from '@/utils/autoCapitalizeName'

export class UpcomingConsultationMapper {
  static parseConsultationId(id: string) {
    if (id?.length > 30) {
      return null
    }

    return parseInt(id)
  }

  static parsePreQueueId(id: string) {
    if (id?.length < 30) {
      return null
    }

    return id
  }

  static parseDateArray(dateArray: number[]) {
    return DateTime.fromObject({
      year: dateArray[0],
      month: dateArray[1],
      day: dateArray[2],
      hour: dateArray[3],
      minute: dateArray[4],
    }).toFormat('dd/MM/yyyy HH:mm:ss')
  }

  static toDomain(data: UpcomingConsultation): UpcomingConsultationData {
    return {
      professional: {
        id: data?.idProfissional,
        name: autoCapitalizeName(data?.nomeProfissional),
        photo: data?.urlFoto,
        specialty: data?.especialidade,
        council: data?.tipoProfissional?.tipoConselho,
        specialtyId: data?.idEspecialidade,
        professionalType: data?.tipoProfissional?.id,
      },
      consultation: {
        id: UpcomingConsultationMapper.parseConsultationId(
          data?.idAtendimento?.toString(),
        ),
        preQueueId: UpcomingConsultationMapper.parsePreQueueId(
          data?.idAtendimento?.toString(),
        ),
        date: UpcomingConsultationMapper.parseDateArray(data?.dataAtendimento),
        token: data?.token,
        isReservation: data?.reserva,
        isReservationConfirmed: data?.reservaConfirmada,
        isConfirmed: data?.flagConsultaConfirmada,
        isRequiredConfirmation:
          data?.confirmacaoAtendimento?.flagConfirmacaoConsultaObrigatoria,
        daysToConfirmReservation:
          data?.confirmacaoAtendimento?.prazoConfirmacaoDias,
        roomId: data?.roomId,
        mode: data?.modoAtendimento,
      },
      default: data,
    }
  }
}
